<template>
    <v-card>
        <v-flex xs12 class="padding checkboxes">
            <v-layout row wrap>
                <p aria-hidden="true" class="v-label v-label--active theme--light pt-1 pr-4" style="text-align: left">{{$t('Give permission to')}}</p>
                <v-switch v-model="permissionViewDownload" color="primary" class="padding" style="margin:0" :label="label_permission"></v-switch>
            </v-layout>
        </v-flex>

        <v-switch v-model="limits" color="primary" class="padding" style="margin:0" :label="label_limits"></v-switch>
        <temporal-permissions v-if="limits" ref="temporal" v-model="temporalPermissions" class="padding">

        </temporal-permissions>

        <v-flex xs12 class="padding checkboxes">
            <v-layout row wrap>
                <v-checkbox v-model="GivePermissionsView" color="primary" :label="$t('Allow re-sharing')"></v-checkbox>
                <v-switch :disabled="!permissionViewDownload" v-if="GivePermissionsView" v-model="GivePermissionsDownload" color="primary" class="padding pt-1" style="margin:0" :label="label_permission_share"></v-switch>
            </v-layout>
        </v-flex>
        <div v-if="invalid_give_permissions" class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
                <div class="v-messages__message">{{$t("You cannot allow the user to concede a permission that doesn't have.")}}</div>
            </div>
        </div>

        <v-layout row style="height:50px;">
            <v-flex xs12>
                <div class="text-center">
                    <v-btn color="darken-1" round @click="close">Close</v-btn>
                    <v-btn round center :loading="loading" color="primary" class="white--text" @click="send">{{$t('Save')}}
                        <v-icon right dark>cloud_upload</v-icon>
                    </v-btn>
                    <span v-if="$user" style="position: relative; top: 5px;color:#A22C32;">{{cost}} <font-awesome-icon color="primary" icon="coins" class="stamina-icon"/></span>
                </div>

            </v-flex>
        </v-layout>

    </v-card>
</template>

<script>
    import FilesRepository from '@/repositories/FilesRepository'
    import TemporalPermissions from '@/components/SharedFilesCard/TemporalPermissions'
    import {VExpansionPanel, VExpansionPanelContent, VBtn,VCard,VIcon,VForm,VTextField,VFlex,VLayout,VCombobox,VImg,VCardActions,VCardTitle, VCheckbox, VSwitch} from 'vuetify/lib'
    import config from "../../config"

    export default {
        components: {VExpansionPanel, VExpansionPanelContent, TemporalPermissions,VBtn,VCard,VIcon,VForm,VTextField,VFlex,VCombobox,VLayout,VImg,VCardActions,VCardTitle, VCheckbox, VSwitch},
        name: "ChangePermission",
        computed:{
            label_limits:function() {
                if (this.limits) return this.$t('Limited accesses (only one allowed)');
                return this.$t('Limited accesses');
            },
            label_permission:function() {
                if (this.permissionViewDownload) return this.$t('View and download')
                return this.$t('View')
            },
            label_permission_share:function() {
                if (this.GivePermissionsDownload) return this.$t('View and download')
                return this.$t('View')
            },
        },
        props: {
            hash: String,
            token: String,
            editEmail: String,
        },
        data () {
            return {
                permissionViewDownload: false,
                limits:true,
                temporalPermissions:null,
                GivePermissionsView:false,
                GivePermissionsDownload:false,
                invalid_give_permissions: false,
                cost: -config.stamina.upload_file
            }
        },
        methods:{
            close:function() {
                this.$root.$emit('close')
            },
            send:function() {
                var POSITION_DOWNLOAD = 4;
                var POSITION_VIEW = 5;

                var permissionList = [0, 0, 0, 0, 0, 0, 0, 0];
                permissionList[POSITION_VIEW] = 1;
                if (this.permissionViewDownload) {
                    permissionList[POSITION_DOWNLOAD] = 1;
                }
                this.loading = true;
                var temporaryPermissionType = null;
                var temporaryPermissionValue = null;
                if (this.limits && this.temporalPermissions) {
                    temporaryPermissionType = this.temporalPermissions.temporalPermission;
                    temporaryPermissionValue = this.temporalPermissions.temporalValue;
                }

                var givePermissionList= [0, 0, 0, 0, 0, 0, 0, 0];
                if (this.GivePermissionsView) {
                    givePermissionList[POSITION_VIEW] = 1;
                }
                if (this.GivePermissionsDownload) {
                    givePermissionList[POSITION_DOWNLOAD] = 1;
                }

                FilesRepository.shareFile(this.hash, [this.editEmail], "", permissionList, temporaryPermissionType, temporaryPermissionValue, givePermissionList, this.token).then(() => {
                    this.$root.$emit('show-snackbar', {message: "File shared successfully", color: 'success', timeout: 6000 });
                }).catch((error) => {
                    this.$root.$emit('show-snackbar', {message: "An error occured", color: 'error', timeout: 6000 });
                });

            },
        }
    }
</script>

<style scoped>

</style>